import { api } from '@/lib/api';
import { z } from 'zod';
import {
  LlmCatalogResponseSchema,
  LlmKeyListResponseSchema,
  LlmKeyRowSchema,
  LlmKeyTestResponseSchema,
  type CreateLlmKeyBody,
  type LlmCatalogResponse,
  type LlmKeyListResponse,
  type LlmKeyRow,
  type LlmKeyTestResponse,
  type ProviderId,
  type UpdateLlmKeyBody,
} from './schemas';

function tenantHeaders(tenantId: string): Record<string, string> {
  return { 'X-Tenant-Id': tenantId };
}

export async function getCatalog(tenantId: string): Promise<LlmCatalogResponse> {
  return api.get('/tenant/settings/llm-catalog', LlmCatalogResponseSchema, {
    headers: tenantHeaders(tenantId),
  });
}

export async function listKeys(tenantId: string): Promise<LlmKeyListResponse> {
  return api.get('/tenant/settings/llm-keys', LlmKeyListResponseSchema, {
    headers: tenantHeaders(tenantId),
  });
}

export async function createKey(tenantId: string, body: CreateLlmKeyBody): Promise<LlmKeyRow> {
  return api.post('/tenant/settings/llm-keys', LlmKeyRowSchema, body, {
    headers: tenantHeaders(tenantId),
  });
}

export async function updateKey(
  tenantId: string,
  id: string,
  body: UpdateLlmKeyBody,
): Promise<LlmKeyRow> {
  return api.patch(`/tenant/settings/llm-keys/${encodeURIComponent(id)}`, LlmKeyRowSchema, body, {
    headers: tenantHeaders(tenantId),
  });
}

export async function deleteKey(tenantId: string, id: string): Promise<{ deleted: true }> {
  return api.delete(
    `/tenant/settings/llm-keys/${encodeURIComponent(id)}`,
    z.object({ deleted: z.literal(true) }),
    { headers: tenantHeaders(tenantId) },
  );
}

export async function testStored(tenantId: string, id: string): Promise<LlmKeyTestResponse> {
  return api.post(
    `/tenant/settings/llm-keys/${encodeURIComponent(id)}/test`,
    LlmKeyTestResponseSchema,
    {},
    { headers: tenantHeaders(tenantId) },
  );
}

export async function testPreSave(
  tenantId: string,
  body: { provider: ProviderId; apiKey: string },
): Promise<LlmKeyTestResponse> {
  return api.post('/tenant/settings/llm-keys/test', LlmKeyTestResponseSchema, body, {
    headers: tenantHeaders(tenantId),
  });
}
